<template>
    <h3 v-if="title" class="section-title">
        <span class="bar"></span>
        <span class="text">{{ title }}</span>
    </h3>
</template>

<script>
export default {
    name: 'SectionTitle',
    props: {
        title: {
            type: String,
            default: ''
        }
    }
};
</script>

<style lang="less" scoped>
.section-title {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 18px;
    display: flex;
    align-items: center;
    color: #1e2330;
    margin-bottom: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .bar {
        width: 2px;
        height: 11px;
        background: #4a70ff;
        border-radius: 4px;
        margin-right: 4px;
        flex: 0 0 2px;
    }

    .text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>
